export default {
  namespaced: true,
  teams: {
    title: "Area",
    name: "Nome",
    description: "Descrição",
  },
};